export { default } from './list-of-arrangements';
